import React from "react";
import companyLogo from "../../assets/ewarLogo.jpg";
import avatarLogo from "../../assets/avatar.png";
import Carousel from "./Carousel";
import { HashLink as Link } from 'react-router-hash-link';
import s1 from "../../assets/contr7/C7S1.png"
import o1 from "../../assets/contr7/C7O1.png"
import o2 from "../../assets/contr7/C7O2.png"
import o3 from "../../assets/contr7/C7O3.png"
import o4 from "../../assets/contr7/C7O4.png"

const Contribution7 = () => {
  const images = [s1]; // Array of image sources for the slideshow

  const nextImage = () => {
    setImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevImage = () => {
    setImageIndex(
      (prevIndex) => (prevIndex - 1 + images.length) % images.length
    );
  };

  return (
    <div className="p-4 mt-8">
      <div
        className=" max-w-max md:max-w-[115rem] mx-auto bg-fgPurple rounded-2xl border-4 border-black p-6"
        style={{ boxShadow: "5px -5px 0px 0px black" }}
        id="experience-section"
      >
        <div className="bg-fgPurple2 flex flex-col items-center justify-center rounded-t-2xl mb-4">
          <Carousel images={images} />
        </div>
        <div className=" h-[400px] md:h-[550px] overflow-y-scroll">
          <div className=" ml-6 flex flex-col mr-4">
            <div className="flex">
              <img
                src={companyLogo}
                alt={`Logo of company`}
                className="mr-6 h-12 w-12 md:h-[5rem] md:w-[5rem] rounded-full border-4 border-black"
              />
              <div>
                <h1 className="font-clash-display-semibold text-base md:text-xl m-0 p-0 leading-5">
                  Ewar Games
                </h1>
                <h2 className="font-clash-display-medium opacity-70 text-xs md:text-lg m-0 p-0 leading-5">
                  Position: Game Designer
                </h2>
              </div>
            </div>

            <div>
              <div
                className="md:max-w-[90%] mt-4 md:ml-16 mr:8 bg-white rounded-2xl border-4 border-black p-6 space-y-2"
                style={{ boxShadow: "3px -3px 0px 0px black" }}
              >
                <p className="text-xs md:text-xl lg:text-2xl font-bold  font-clash-display-semibold m-0 p-0 lg:leading-5">
                   He worked on the following features:
                </p>
                <ul>
                  <li className="text-xs md:text-xl lg:text-2xl font-clash-display-semibold">• variable rotation speeds</li>
                  <li className="text-xs md:text-xl lg:text-2xl font-clash-display-semibold">• smooth board rotation</li>
                  <li className="text-xs md:text-xl lg:text-2xl font-clash-display-semibold">• Total Knives indicator</li>
                  <li className="text-xs md:text-xl lg:text-2xl font-clash-display-semibold">• board variations</li>
                  <li className="text-xs md:text-xl lg:text-2xl font-clash-display-semibold">• BossFight</li>
                  <li className="text-xs md:text-xl lg:text-2xl font-clash-display-semibold">• hitting targets</li>
                  <li className="text-xs md:text-xl lg:text-2xl font-clash-display-semibold">• Blade/Dagger Variation</li>
                  <li className="text-xs md:text-xl lg:text-2xl font-clash-display-semibold">• Blade Slider - left to right (angled)</li>
                  <li className="text-xs md:text-xl lg:text-2xl font-clash-display-semibold">• Knife charging by hold (capped to 3 total charges)</li>
                  <li className="text-xs md:text-xl lg:text-2xl font-clash-display-semibold">• board chipping on charged hit</li>
                  <li className="text-xs md:text-xl lg:text-2xl font-clash-display-semibold">• Ghost/Faded Knife for player empty knives</li>
                </ul>
              </div>
              <p className="text-right mt-4 mr-20 lg:mr-40 font-clash-display-medium text-xs md:text-lg opacity-70">
                From April 2021 to March 2022
              </p>
            </div>
          </div>
          <div className=" mt-4 ml-6 flex flex-col mr-4">
            <div className="flex">
              <img
                src={avatarLogo}
                alt={`Avatar`}
                className="mr-6 h-12 w-12 md:h-[5rem] md:w-[5rem] rounded-full object-cover shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] bg-white border-2 border-black flex-shrink-0"
              />
              <div>
                <h1 className=" font-clash-display-semibold text-sm md:text-xl m-0 p-0 leading-5">
                  Arinjay Choudhury
                </h1>
                <h2 className=" font-clash-display-medium opacity-70 text-xs md:text-lg m-0 p-0 leading-5">
                  Position: Game Designer
                </h2>
              </div>
            </div>

            <div>
              <div
                className="md:max-w-[50%] mt-4 md:ml-16 mr:8 bg-fgGreen rounded-2xl border-4 border-black p-6 space-y-2"
                style={{ boxShadow: "3px -3px 0px 0px black" }}
              >
                <p className=" ml-4 font-clash-display-semibold text-sm md:text-2xl">
                  {" "}
                  Here is the Overhauled Design !
                </p>
                <div
                  className="bg-black rounded-2xl border-2 border-black m-auto w-fit h-[30vh] md:h-[50vh]"
                  style={{ boxShadow: "4px 4px 0px 0px black" }}
                >
                  <img src={o3} className=" w-full h-full max-w-full max-h-full rounded-2xl"></img>
                </div>
                <div
                  className="bg-black rounded-2xl border-2 border-black m-auto w-fit h-[30vh] md:h-[50vh]"
                  style={{ boxShadow: "4px 4px 0px 0px black" }}
                >
                  <img src={o4} className=" w-full h-full max-w-full max-h-full rounded-2xl"></img>
                </div>
              </div>  
            </div>
            <div>
              <div
                className="md:max-w-[50%] mt-4 md:ml-16 mr:8 bg-fgGreen rounded-2xl border-4 border-black p-6 space-y-2"
                style={{ boxShadow: "3px -3px 0px 0px black" }}
              >
                <p className=" ml-4 font-clash-display-semibold text-sm md:text-2xl">
                  {" "}
                  Here are some extra boards !
                </p>
                <div
                  className="bg-black rounded-2xl border-2 border-black m-auto w-fit h-[30vh] md:h-[50vh]"
                  style={{ boxShadow: "4px 4px 0px 0px black" }}
                >
                  <img src={o1} className=" w-full h-full max-w-full max-h-full rounded-2xl"></img>
                </div>
                <div
                  className="bg-black rounded-2xl border-2 border-black m-auto w-fit h-[30vh] md:h-[50vh]"
                  style={{ boxShadow: "4px 4px 0px 0px black" }}
                >
                  <img src={o2} className=" w-full h-full max-w-full max-h-full rounded-2xl"></img>
                </div>
              </div>  
            </div>
          </div>
        </div>
        {/* Comment section and MyContributions Box */}
        <div className="flex justify-normal gap-5 p-2 mt-8">
          <div className={`bg-fgPurple2 rounded-2xl py-4 px-12 w-[100vw]`}>
            <h2
              className={`text-white text-xl md:text-xl font-clash-display-semibold`}
            ></h2>
          </div>
          <Link smooth to="/#my-works-section">
          <div
            className="inline-block bg-fgYellow rounded-2xl shadow-md border-2 md:border-4 border-black p-2 md:py-4 md:px-12"
            style={{ boxShadow: "-3px 3px 0px 0px black" }}
          >
          
            <h2 className=" md:whitespace-nowrap text-xs md:text-3xl text-center font-clash-display-semibold">
              My Contribution
            </h2> 
          </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Contribution7;
